import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=6bb077ac&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginForm.vue?vue&type=style&index=1&id=6bb077ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb077ac",
  null
  
)

export default component.exports